export default {
  methods: {

    gmx_header_Depth2(selection, data, height, tx, space, id) {

      let dataCol = data.cols.filter(f=> f.dps > 0)

      this.gmx_tableCoordinates('x', dataCol, space)
      data.width = data.cols[dataCol.length-1].ex

      let sys = selection
      .append('g')
      .attr('transform', `translate(${data.x}, ${data.y})`)
      
      sys
      .append('text')
      .attr('id', `TITLE_${id}`)
      .attr('x', 0).attr('y', -3)
      .attr('font-size', 13).attr('fill', '#44A9DF')
      .text(data.title)

      sys
      .append('text')
      .attr('id', `NO_${id}`)
      .attr('x', this.getNode(`#TITLE_${id}`)+5).attr('y', -3)
      .attr('font-size', 13).attr('fill', '#000')
      .text('')

      sys
      .append('text')
      .attr('id', `DESC_${id}`)
      .attr('x', 0).attr('y', -3)
      .attr('font-size', 10).attr('fill', '#333')
      .text('')

      sys
      .append('path') // shadow
      .attr('d', `M5,${height + 2} H ${data.width-7} L ${data.width},${height + 7} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      sys
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', data.width).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      sys
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', data.width).attr('height', height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      // sys
      // .append('rect')
      // .attr('x', 0).attr('y', 2).attr('width', data.width).attr('height', height)
      // .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .2)

      sys
      .append('rect') 
      .attr('x', 0).attr('y', height + 1).attr('width', data.width).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`)


      data.cols.filter(f=> f.dps == undefined).forEach(h=> {
        let x_ = data.cols[h.sx].sx + (data.cols[h.ex].ex - data.cols[h.sx].sx)/2
        sys
        .append('text')
        .attr('x', x_).attr('y', data.depth[0].y)
        .attr('font-size', 10).attr('fill', '#000').attr('text-anchor', 'middle')
        .text(h.name)
      })

      dataCol.forEach((col,c)=> {
        sys
        .append('text')
        .attr('x', col[tx]).attr('y', data.depth[col.dps].y)
        .attr('font-size', data.depth[col.dps].tSize).attr('fill', data.depth[col.dps].tColor).attr('text-anchor', 'middle')
        .text(col.name)
      })
    },




  }
}